<script setup lang="ts">
import type { Currency, Price, ProductAccessory } from '~/types/api'

const props = defineProps<{
  accessory: ProductAccessory
  price?: Price
  currency: Currency | null
  priceLoading?: boolean
}>()
const image = props.accessory.images[0]
const { getResourceUrl } = useResources()

const userStore = useUser()
const { showPrices } = storeToRefs(userStore)
</script>

<template>
  <div class="border-b-4 border-r-4 border-white px-6 py-3">
    <div class="font-pragmatica-ext pb-5 text-lg font-bold">
      {{ accessory.title }}
    </div>
    <div class="group relative w-full">
      <img
        class="lazy-img h-full w-full object-contain group-hover:opacity-10"
        :src="getResourceUrl(image?.url + '/576x576/FIT')"
        :alt="image?.metaAlt"
        :title="image?.metaTitle"
      />
      <ul
        class="absolute left-0 top-0 z-50 hidden h-full w-full list-disc flex-col overflow-y-auto pl-4 align-middle text-xs group-hover:flex"
      >
        <li
          v-for="descriptionItem in accessory.descriptionItems"
          :key="descriptionItem.nid"
          class="pb-[2px]"
        >
          {{ descriptionItem.title }}
        </li>
      </ul>
    </div>
    <div v-if="priceLoading" class="mb-2 h-5 w-5 pt-2">
      <UiSpinner />
    </div>
    <div
      v-else-if="props.price && showPrices && props.currency"
      class="font-pragmatica-ext pt-4 text-sm font-bold"
    >
      {{ '+ ' + formatPrice(price?.price ?? 0, currency) }}
    </div>
  </div>
</template>

<style scoped></style>
